import { filter, map } from 'underscore';
import {
  BaseSurvey,
  WebuiUserSurvey,
  EscWebuiUserSurvey,
  EscWebuiUserPauseCampaignSurvey,
  EscWebuiAutomatedAdDeletionSurvey,
  EscWebuiCampaignFeedbackSurvey,
  AdInsightRecommendationSurvey,
  AdInsightRecommendationMccSurvey,
  EscWebuiUserCancelSignupSurvey,
  McmWebuiOptOutFeedbackSurvey,
  MCMMandatoryOptOutSurvey,
  AssetLibraryAIGCMVPSurvey,
  AssetLibraryAppSurvey,
  AssetLibraryPickerSurvey,
  CopilotAssetRecommendationSatisfactionSurvey,
  ReportingWebuiUserSurvey,
  RSALLMSuggestionOverallSurvey,
  RSALLMSuggestionMostWantedSurvey,
  CampaignOnboardingSurvey,
  TransparentImageAnnotationSurvey,
  BudgetCenterOverallSatisfactionSurvey,
  BudgetCenterOneTimeUserSurvey,
  AdsStudioAppSurvey,
} from '@bingads-webui-campaign-react/survey-core';

// register the surveys
const webuiSurveyList = [
  BudgetCenterOneTimeUserSurvey, // The lowest priority
  WebuiUserSurvey,
  EscWebuiUserSurvey,
  EscWebuiUserPauseCampaignSurvey,
  EscWebuiAutomatedAdDeletionSurvey,
  EscWebuiCampaignFeedbackSurvey,
  AdInsightRecommendationSurvey,
  AdInsightRecommendationMccSurvey,
  EscWebuiUserCancelSignupSurvey,
  McmWebuiOptOutFeedbackSurvey,
  MCMMandatoryOptOutSurvey,
  AssetLibraryAIGCMVPSurvey,
  AssetLibraryAppSurvey,
  AssetLibraryPickerSurvey,
  CopilotAssetRecommendationSatisfactionSurvey,
  ReportingWebuiUserSurvey,
  RSALLMSuggestionOverallSurvey,
  RSALLMSuggestionMostWantedSurvey,
  CampaignOnboardingSurvey,
  TransparentImageAnnotationSurvey,
  BudgetCenterOverallSatisfactionSurvey,
  AdsStudioAppSurvey,
];

const getImplementedSurveyList = surveyList =>
  filter(surveyList, survey => survey.prototype instanceof BaseSurvey);

export const getWebuiSurveyList = (props) => {
  const implementedSurveyList = getImplementedSurveyList(webuiSurveyList);
  return map(implementedSurveyList, Survey => new Survey(props));
};
